<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="ClientName"
        @sortChanged="event => emit('sortChanged', event)"
        @loadMore="emit('loadMore')">
         <template #col-id="{ row }">   
               {{ row.start_hour }} - {{ row.end_hour }} Hrs.
        </template>
         <template #col-pallet_price="{ row }">
               {{ formatCurrency(row.pallet_price,'USD') }}
        </template>
         <template #col-box_price="{ row }">
               {{ formatCurrency(row.box_price,'USD') }}
        </template>
         <template #col-bulk_price="{ row }">
               {{ formatCurrency(row.bulk_price,'USD') }}
        </template>
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView.vue'
import { formatCurrency } from '@/utils/helpers'

const emit = defineEmits(['sortChanged', 'loadMore', 'edit', 'delete'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'id', label: 'range', sortable: true },
    { key: 'pallet_price', label: 'pallet', sortable: true },
    { key: 'box_price', label: 'box', sortable: true },
    { key: 'bulk_price', label: 'bulk', sortable: true },
])

const actionButtons = ref([
    { text: 'edit', icon: 'EditIcon', color: 'warning', permissions: ['IU PREEXPENSES EDIT'], onClick: row => emit('edit', row) },
    { text: 'delete', icon: 'TrashIcon', color: 'danger', permissions: ['IU PREEXPENSES EDIT'], onClick: row => emit('delete', row) }
])


</script>
